var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconsLocked({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#0071b9;}.b{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-171 -465)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M16,8.675V18.2a1.42,1.42,0,0,0,1.419,1.419H27.553A1.421,1.421,0,0,0,28.972,18.2V8.675ZM27.35,18H17.621V10.3H27.35ZM18.434,7.417H16.812V5.8a5.674,5.674,0,0,1,11.347,0V7.417H26.538V5.8a4.053,4.053,0,0,0-8.1,0Z",
    transform: "translate(161 466.796)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 24,
    height: 24,
    transform: "translate(171 465)"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsLocked);
export default __webpack_public_path__ + "static/media/icons-locked.3ac931bc.svg";
export { ForwardRef as ReactComponent };